<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let checked = false;
  export let key = "";
  export let disabled = false;

  const dispatch = createEventDispatcher<{ change: boolean }>();

  function onChange() {
    dispatch("change", !checked);
  }
</script>

<button class="relative inline-flex items-start cursor-pointer" on:click|stopPropagation={onChange}>
  <input type="checkbox" class="sr-only peer" bind:checked {disabled} data-testid={`toggle ${key}`} />
  <div
    class="w-9 h-5 bg-[--color-grayscale-50] rounded-full peer
               dark:bg-[--color-grayscale-70] peer-checked:after:translate-x-full
               after:content-[''] after:absolute after:top-[0.1rem] after:left-[2px]
               after:bg-white after:border-[--color-grayscale-20] after:border
               after:rounded-full after:h-4 after:w-4 after:transition-all
               peer-checked:bg-[--color-purple-50] peer-disabled:bg-[color-grayscale-30]" />
</button>

